function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}function _createForOfIteratorHelper(o, allowArrayLike) {var it;if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {if (it) o = it;var i = 0;var F = function F() {};return { s: F, n: function n() {if (i >= o.length) return { done: true };return { done: false, value: o[i++] };}, e: function e(_e) {throw _e;}, f: F };}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var normalCompletion = true,didErr = false,err;return { s: function s() {it = o[Symbol.iterator]();}, n: function n() {var step = it.next();normalCompletion = step.done;return step;}, e: function e(_e2) {didErr = true;err = _e2;}, f: function f() {try {if (!normalCompletion && it.return != null) it.return();} finally {if (didErr) throw err;}} };}function _unsupportedIterableToArray(o, minLen) {if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);}function _arrayLikeToArray(arr, len) {if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {arr2[i] = arr[i];}return arr2;}var inputMap = {
  down: {
    pointer: 'pointerdown',
    mouse: 'mousedown',
    touch: 'touchstart' },

  up: {
    pointer: 'pointerup',
    mouse: 'mouseup',
    touch: 'touchend' },

  move: {
    pointer: 'pointermove',
    mouse: 'mousemove',
    touch: 'touchmove' } };



function _getInputEvents(type) {
  if (Autodesk.Viewing.isIE11) {
    return [inputMap[type].pointer];
  }

  var events = [];
  if (!Autodesk.Viewing.isMobileDevice()) {
    events.push(inputMap[type].mouse);
  }

  if (Autodesk.Viewing.isTouchDevice()) {
    events.push(inputMap[type].touch);
  }

  return events;
}

function addRemoveInputEvents(elem, type, cb) {var isRemoving = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var action = (isRemoving ? 'remove' : 'add') + 'EventListener';
  var events = _getInputEvents(type);var _iterator = _createForOfIteratorHelper(
  events),_step;try {for (_iterator.s(); !(_step = _iterator.n()).done;) {var event = _step.value;
      elem[action](event, cb);
    }} catch (err) {_iterator.e(err);} finally {_iterator.f();}
}var

SplitViewResizeHandler = /*#__PURE__*/function () {
  function SplitViewResizeHandler(container, onMoveCB) {_classCallCheck(this, SplitViewResizeHandler);
    this.container = container;
    this.isDragging = false;
    this.resizeHandlerElement = null;
    this.onMoveCB = onMoveCB;
    this.panelSizeThreshold = 20;
    this.margin = 16;
    this.initResizeHandlerElement();
  }_createClass(SplitViewResizeHandler, [{ key: "onDown", value: function onDown(

    e) {
      this.isDragging = true;
      e.preventDefault();
    } }, { key: "onUp", value: function onUp(

    e) {
      this.isDragging = false;
    } }, { key: "onMove", value: function onMove(

    e) {
      if (this.isDragging) {
        if (e.type === 'touchmove') {
          e.pageX = e.touches[0].pageX;
          e.pageY = e.touches[0].pageY;
        }

        var rect = this.container.getBoundingClientRect();

        var targetWidthPercentage = this.getTargetWidthPercentage(e, rect);

        if (this.panelSizeThreshold < targetWidthPercentage && targetWidthPercentage < 100 - this.panelSizeThreshold) {
          this.onMoveCB(targetWidthPercentage);
        }
      }
    } }, { key: "getTargetWidthPercentage", value: function getTargetWidthPercentage(

    e, rect) {
      // Override
    } }, { key: "initResizeHandlerElement", value: function initResizeHandlerElement()

    {
      this.resizeHandlerElement = document.createElement('div');
      this.handlerSplitLine = document.createElement('div');
      this.resizeHandlerElement.appendChild(this.handlerSplitLine);

      addRemoveInputEvents(this.resizeHandlerElement, 'down', this.onDown.bind(this));

      this.onUpBinded = this.onUp.bind(this);
      this.onMoveBinded = this.onMove.bind(this);

      addRemoveInputEvents(document, 'move', this.onMoveBinded);
      addRemoveInputEvents(document, 'up', this.onUpBinded);

      this.resizeHandlerElement.className = 'resize-handler';
      this.handlerSplitLine.className = 'resize-handler-center-mark';
    } }, { key: "setPosition", value: function setPosition(

    percentage) {
      // Override
    } }, { key: "terminate", value: function terminate()

    {
      this.resizeHandlerElement.parentNode.removeChild(this.resizeHandlerElement);
      this.resizeHandlerElement = null;
      addRemoveInputEvents(document, 'up', this.onUpBinded, true);
      addRemoveInputEvents(document, 'move', this.onMoveBinded, true);
    } }]);return SplitViewResizeHandler;}();export { SplitViewResizeHandler as default };